// extracted by mini-css-extract-plugin
export default {"error":"error_error__6ju7V","text":"error_text__6uyrN","title":"error_title__uoAf5"};